import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/humanResources/job_managment';
import Container from './Container';


const ms2p = (state) => {
    return {
        ...state.jobManagment,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Container);
